var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 text-sm-right"},[_c('p',[_vm._v("© "+_vm._s(_vm.currentYear)+" Wiremit. All rights reserved.")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }